import Button from "@/components/ui/Button";
import { useAuth } from "@/hooks/auth/useAuth";
import { signInWithGoogle } from "@/app/providers/authActions";

export default function LoginButton() {
  const { firebaseUser, loading } = useAuth();

  if (loading) return null;

  if (firebaseUser) return null;

  async function handleLogin() {
    try {
      await signInWithGoogle();
    } catch (err) {
      console.error("Login failed:", err);
      alert("Login failed.");
    }
  }

  return (
    <Button variant="secondary" onClick={handleLogin}>
      Sign in with Google
    </Button>
  );
}
